import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordShopIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_28768_7134)">
        <path
          d="M11.2583 4.83131C11.2573 5.19303 11.1445 5.54561 10.9352 5.84066C10.726 6.13571 10.4306 6.35879 10.0895 6.47929C9.90303 6.55001 9.70511 6.58566 9.50569 6.58445C9.14398 6.58344 8.79145 6.47057 8.49641 6.26133C8.20137 6.05209 7.97828 5.75671 7.85771 5.41569C7.78693 5.22905 7.75128 5.03092 7.75255 4.83131C7.75425 5.03084 7.71844 5.22924 7.64738 5.41569C7.52692 5.75666 7.30393 6.05203 7.00899 6.26127C6.71405 6.47052 6.3616 6.5834 5.99998 6.58445C5.63835 6.5834 5.28591 6.47052 4.99097 6.26127C4.69603 6.05203 4.47304 5.75666 4.35257 5.41569C4.28177 5.22905 4.24611 5.03093 4.24741 4.83131C4.24854 5.03084 4.2133 5.22924 4.14224 5.41569C4.02175 5.75676 3.79867 6.05218 3.50362 6.26143C3.20856 6.47069 2.85599 6.58352 2.49427 6.58445C2.29531 6.58559 2.09635 6.55034 1.91046 6.47929C1.56944 6.35872 1.27406 6.13562 1.06482 5.84059C0.855575 5.54555 0.742711 5.19301 0.741699 4.83131L1.00433 3.9087L1.63532 2.10895C1.71543 1.87998 1.8648 1.68162 2.06271 1.54136C2.26062 1.4011 2.49727 1.32589 2.73984 1.32617H9.26011C9.50259 1.32601 9.73911 1.40127 9.93691 1.54152C10.1347 1.68177 10.284 1.88007 10.3641 2.10895L10.9951 3.9087L11.2583 4.83131Z"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0894 6.479V9.5055C10.0892 9.81527 9.96608 10.1123 9.74703 10.3314C9.52799 10.5504 9.23094 10.6735 8.92116 10.6737H3.07794C2.92448 10.6738 2.77251 10.6436 2.63072 10.5849C2.48892 10.5263 2.36007 10.4402 2.25154 10.3317C2.143 10.2233 2.0569 10.0944 1.99816 9.95268C1.93941 9.81091 1.90918 9.65895 1.90918 9.5055V6.479M4.24727 8.92112H7.75241"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_28768_7134">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordShopIcon;
